
export default {
  props: {
    accidentStatus: String
  }
}
